<script setup lang="ts">
defineExpose({});
</script>
<template>
    <div class="card">
        <slot />
    </div>
</template>
<style scoped lang="scss">
.card {
    width: 399px;
    background-color: #ffffff;
    box-shadow: 0px 1px 16px #00000029;
    border-radius: 8px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1002;

    @media (max-width: 450px) {
        width: calc(100% - 48px);
    }
}
</style>
